(ns minorodata.file-ingest.events
  (:require [minorodata.app.handlers :refer [reg-event-fx]]
            [minorodata.file-ingest.model :as fi.model]
            [minorodata.utils :as utils]))


(reg-event-fx
  :file-ingest.events/set-wizard-step
  (fn [_ [step]]
    (let [wizard-step (-> (utils/find-by-field fi.model/wizard-steps :step step)
                          (select-keys [:step :page-title])
                          fi.model/->ingest-step)]
      {:dispatch [:ingest-step/update wizard-step]})))


(reg-event-fx
  :file-ingest.events/set-uploaded-file
  (fn [_ [bucket file-path]]
    (let [ingest-file (-> {:bucket bucket
                           :path   file-path}
                          fi.model/->ingest-file)]

      {:dispatch-n [[:ingest-file/delete]
                    [:ingest-file/add ingest-file]
                    [:file-ingest.api/fetch-sheets file-path]]})))


(reg-event-fx
 :file-ingest.events/set-selected-sheet
 (fn [_ [sheet]]
   {:dispatch-n [[:ingest-preview-data/delete]
                 [:ingest-selected-sheet/add (fi.model/->ingest-selected-sheet
                                              {:name sheet})]
                 [:file-ingest.events/set-wizard-step :preview-data]]}))


(reg-event-fx
  :file-ingest.events/set-ingest-table-params
  (fn [_ [table-type table-name]]
    (let [type         (keyword table-type)
          table-params (-> {:type       type
                            :table-name table-name}
                           fi.model/->ingest-table-params)
          next-step    (if (= type :existing)
                         :confirmation
                         :column-select)]
      {:dispatch-n [[:ingest-table-params/add table-params]
                    [:file-ingest.events/set-wizard-step next-step]]})))


(reg-event-fx
 :file-ingest.events/set-header-row
 (fn [_ [header-row]]
   {:dispatch-n [[:ingest-header-row/add (-> {:header-idx header-row}
                                             fi.model/->ingest-header-row)]
                 [:file-ingest.events/set-wizard-step :table-select]]}))


(reg-event-fx
  :file-ingest.events/set-selected-columns
  (fn [_ [selected-columns]]
    {:dispatch-n [[:ingest-selected-columns/add (-> {:columns selected-columns}
                                                    fi.model/->ingest-selected-columns)]
                  [:file-ingest.events/set-wizard-step :confirmation]]}))
